import { useAISummaryStore } from "../store/aiSummaryStore";

export default function useFilterActions() {
  const { chipData, setChipData, setReadNotes, resetCurrentPage } = useAISummaryStore();

  function handleSelection(selectedValue) {
    if (chipData.find((item) => item.key === selectedValue.key)) {
      handleDeleteChip(selectedValue);
    } else {
      setChipData([selectedValue]);
      setReadNotes(selectedValue?.value);
      resetCurrentPage();
    }
  }

  const handleDeleteChip = (value) => {
    const filteredData = chipData.filter((chip) => chip.key !== value.key);
    setChipData(filteredData);

    if (filteredData.length === 0) {
      setReadNotes(null);
    }
    resetCurrentPage();
  };

  return { handleSelection, handleDeleteChip };
}
